/* tslint:disable */
/* eslint-disable */
/**
 * CMS API
 * The CMS API!
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { ContentListUIModuleContentTreatment } from './content-list-uimodule-content-treatment';
import { EntitlementType } from './entitlement-type';
import { LocalizedFieldBody } from './localized-field-body';
import { TargetPlatform } from './target-platform';
import { UiModuleExperimentGroup } from './ui-module-experiment-group';

/**
 * 
 * @export
 * @interface ContentListUiModuleBody
 */
export interface ContentListUiModuleBody {
    /**
     * 
     * @type {string}
     * @memberof ContentListUiModuleBody
     */
    moduleId?: string;
    /**
     * 
     * @type {string}
     * @memberof ContentListUiModuleBody
     */
    slug?: string;
    /**
     * 
     * @type {string}
     * @memberof ContentListUiModuleBody
     */
    hash?: string;
    /**
     * 
     * @type {string}
     * @memberof ContentListUiModuleBody
     */
    moduleType: ContentListUiModuleBodyModuleTypeEnum;
    /**
     * 
     * @type {Array<TargetPlatform>}
     * @memberof ContentListUiModuleBody
     */
    targetPlatform?: Array<TargetPlatform>;
    /**
     * 
     * @type {LocalizedFieldBody}
     * @memberof ContentListUiModuleBody
     */
    caption?: LocalizedFieldBody;
    /**
     * 
     * @type {Array<EntitlementType>}
     * @memberof ContentListUiModuleBody
     */
    entitlements?: Array<EntitlementType>;
    /**
     * 
     * @type {Array<UiModuleExperimentGroup>}
     * @memberof ContentListUiModuleBody
     */
    experiments?: Array<UiModuleExperimentGroup> | null;
    /**
     * 
     * @type {LocalizedFieldBody}
     * @memberof ContentListUiModuleBody
     */
    title: LocalizedFieldBody;
    /**
     * 
     * @type {boolean}
     * @memberof ContentListUiModuleBody
     */
    isPlaylist?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ContentListUiModuleBody
     */
    useCollectionTitle?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ContentListUiModuleBody
     */
    reorderBasedOnRecommendation?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ContentListUiModuleBody
     */
    contentListId: string;
    /**
     * 
     * @type {ContentListUIModuleContentTreatment}
     * @memberof ContentListUiModuleBody
     */
    contentTreatment: ContentListUIModuleContentTreatment;
    /**
     * 
     * @type {string}
     * @memberof ContentListUiModuleBody
     */
    landscapeFillImage?: string;
    /**
     * 
     * @type {string}
     * @memberof ContentListUiModuleBody
     */
    portraitFillImage?: string;
    /**
     * 
     * @type {string}
     * @memberof ContentListUiModuleBody
     */
    portraitShortNovelFeatured?: string;
    /**
     * 
     * @type {string}
     * @memberof ContentListUiModuleBody
     */
    sponsorLogo?: string;
    /**
     * 
     * @type {string}
     * @memberof ContentListUiModuleBody
     */
    trackingPixelUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof ContentListUiModuleBody
     */
    sponsorStartDate?: string;
    /**
     * 
     * @type {string}
     * @memberof ContentListUiModuleBody
     */
    sponsorEndDate?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum ContentListUiModuleBodyModuleTypeEnum {
    CONTENT_LIST = 'CONTENT_LIST'
}



